import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormBuilder from '../helpers/form-builder';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';

class TicketOwnerDialog extends Component {
    constructor(props) {
        super(props);

        this.displayTicketsDialogForm = this.displayTicketsDialogForm.bind(this);
        this.handleSaveAndContinue = this.handleSaveAndContinue.bind(this);

        this.state = { modalFormData: {} };
    }

    displayTicketsDialogForm() {
        const { formData } = this.props;
        const { firstName, lastName } = formData;
        const modalFormData = { firstName, lastName };

        return FormBuilder({
            formData: modalFormData,
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => {
                const eventTarget = event.target;
                const fieldName = eventTarget.name;
                const fieldData = modalFormData[fieldName];
                this.setState(formStateHelpers.handleFieldChangeWithValidation(eventTarget, fieldData));
            },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state;
                return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            },
        });
    }

    handleSaveAndContinue(event) {
        event.preventDefault();
        const { onSaveAndContinueClick } = this.props;
        const { firstName, lastName } = this.state;
        onSaveAndContinueClick(firstName, lastName);
    }

    render() {
        const { formData, handleCloseTicketDialog } = this.props;
        const { printTicketDialogText } = formData;
        return (
            <div className='ticket-dialog' >
                <div className='notification'>
                    {printTicketDialogText}
                </div>
                {this.displayTicketsDialogForm()}
                <div className='buttons-container'>
                    <a
                        href=''
                        className='close-dialog'
                        onClick={handleCloseTicketDialog}>
                        <span className='ico'>
                            <svg
                                aria-hidden='true'
                                focusable='false'
                                data-prefix='fal'
                                data-icon='times'
                                role='img'
                                xmlns='http://www.w3.org/2000/svg'
                                viewBox='0 0 320 512'
                                className='svg-inline--fa fa-times fa-w-10 fa-2x'>
                                <path
                                    fill='currentColor'
                                    d='M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z'
                                    className=''>
                                </path>
                            </svg>
                        </span>
                        <span className='text'>{formMessageConstants.close}</span>
                    </a>
                    <a href='' className='yellow-button' onClick={this.handleSaveAndContinue}>{formMessageConstants.saveAndContinue}</a>
                </div>
            </div >
        );
    }
}

TicketOwnerDialog.propTypes = {
    formData: PropTypes.object.isRequired,
    onSaveAndContinueClick: PropTypes.func.isRequired,
};

export default TicketOwnerDialog;
